/**
 * Shared layout for the setup flow: Card, header, optional StepProgressBar, and content area.
 * Used by setupPage and performanceOnboardingBanner (SetupModal) so step chrome stays in sync.
 */
import { Box, Card, CardContent, Typography } from "@mui/material";
import StepProgressBar from "./progressBar";
import {
  getStepHeaderLabel,
  getSetupFlowCardSx,
  getSetupFlowCardContentSx,
  stepTitles,
} from "../config/setupFlowSteps";

export default function SetupFlowLayout({
  stepperStep,
  part2Step,
  currentPartStep,
  children,
  headerExtra = null,
  footer = null,
  sx: sxOverride,
}) {
  const showHeader = stepperStep === 0 || stepperStep === 2 || stepperStep === 3;
  const showProgressBar = stepperStep === 0 || stepperStep === 2;
  const progressTotalSteps = stepperStep === 0 ? 3 : 4;
  const stepTitle = stepTitles[stepperStep]?.[currentPartStep] ?? "";

  return (
    <Card
      sx={{
        ...getSetupFlowCardSx(stepperStep, part2Step),
        ...sxOverride,
      }}
    >
      {showHeader && (
        <Box
          sx={{
            borderBottom: "1px solid #e0e0e0",
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "64px",
            flexShrink: 0,
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            {getStepHeaderLabel(stepperStep)}
          </Typography>
          {headerExtra}
        </Box>
      )}
      <CardContent sx={getSetupFlowCardContentSx(stepperStep, part2Step)}>
        {showProgressBar && (
          <StepProgressBar
            currentStep={currentPartStep + 1}
            totalSteps={progressTotalSteps}
            stepTitle={stepTitle}
          />
        )}
        {children}
      </CardContent>
      {footer}
    </Card>
  );
}
